import { useStructuredOutlineStore } from "src/components/StoryBible/StructuredOutline/StructuredOutlineStore";
import { useStoryBibleStore } from "src/stores/storyBibleStore";
import { Outline, OutlineItem, Scene } from "../../../src/shared/types";

export const useGetLinkedChapter = (documentId: string) => {
  const outline: Outline = useStructuredOutlineStore((state) => state.outline);
  const scenes: Scene = useStoryBibleStore((state) => state.scenes);

  if (!documentId || !outline || !scenes) {
    return;
  }

  const documentScene = Object.values(scenes).find((scene: Scene[0]) => scene.contents.type === "document" && scene.contents.id === documentId);
  if (!documentScene) {
    return;
  }

  const linkedChapter = outline.content.items.find((item: OutlineItem) => item.id === documentScene.itemId);
  if (!linkedChapter) {
    return;
  }

  return linkedChapter;
};
